import { render, staticRenderFns } from "./AddEvent.vue?vue&type=template&id=ff55f134&scoped=true"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"
import style0 from "./AddEvent.vue?vue&type=style&index=0&id=ff55f134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff55f134",
  null
  
)

export default component.exports